import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormSelect } from 'common/components/form';

const TypeProposalTemplate = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const onChange = () => setValue('template', '');
    const options = [
        { label: t('Template'), value: 'template' },
        { label: t('API document'), value: 'api' },
    ];
    return (
        <ReactHookFormSelect
            control={control}
            disabled={disabled}
            label={t('Document to use')}
            name="type_proposal_template"
            onChange={onChange}
            options={options}
        />
    );
};

TypeProposalTemplate.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default TypeProposalTemplate;
